require('core-js/fn/map');
require('core-js/fn/set');
require('core-js/fn/weak-map');
require('core-js/fn/weak-set');
require('core-js/fn/string/includes');
require('core-js/fn/string/starts-with');
require('core-js/fn/string/ends-with');
require('core-js/fn/array/from');
require('core-js/fn/array/includes');
require('core-js/fn/promise');

require('classlist-polyfill');
require('element-closest');
require('setimmediate');
require('intersection-observer');

if (document.documentMode || /Edge/.test(navigator.userAgent)) {
  // setImmediate polyfill uses postMessage method
  // IE and EDGE has a bug with same domain sending
  //
  // there's the bug description in setImmediate polyfill repo:
  // https://github.com/YuzuJS/setImmediate/issues/35
  //
  // note that the bug is confirmed by Microsoft developers since 2015 and is totally ignored:
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/3169349/
  window.setImmediate = window.setTimeout;
}

window.Element.prototype.matches = require('./element-prototype-matches');
window.CustomEvent = require('./custom-event');
